import { LanguageClient } from 'clients/languages';
import { Translator } from 'Translator';
import { constants } from 'flux/stores/TranslationStore';

export default {
  translations: {
    setLanguageCode(languageCode) {
      if (window.wlAuthToken) {
        LanguageClient.setPreferredLanguage(languageCode).then(() => {
          Translator.setLanguageCode(languageCode);
          this.dispatch(constants.SET_LANGUAGECODE, languageCode);
        });
      } else {
        Translator.setLanguageCode(languageCode);
        this.dispatch(constants.SET_LANGUAGECODE, languageCode);
      }
    },
  },
};
